var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationTicket = function SvgNotificationTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.583 12.25H4.667A2.917 2.917 0 0 1 1.75 9.333V4.667A2.917 2.917 0 0 1 4.667 1.75h4.666a2.917 2.917 0 0 1 2.917 2.917v2.916a4.667 4.667 0 0 1-4.667 4.667",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.25 5.833v.584c0 .644-.522 1.166-1.167 1.166H9.917a2.333 2.333 0 0 0-2.334 2.334v1.166c0 .645-.522 1.167-1.166 1.167h-.584"
  })));
};
export { SvgNotificationTicket as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWU2Y2VhN2RlMTgwNWVhOWRiM2E1Y2M5Mjg2OTQ1YmUuc3ZnIjs=";